import { createAsyncThunk } from '@reduxjs/toolkit';

import { fetchProductReviewsClient } from 'src/services/product-reviews/fetchProductReviewsClient';
import type { ReviewsPage } from 'src/services/product-reviews/types';
import { fetchReviewSummary } from 'src/services/reviews-summary-api/fetchReviewSummary';
import type { ReviewSummaryResponse } from 'src/services/reviews-summary-api/types/ReviewSummaryResponse';
import type { ReviewRatingFilter } from './types';

export interface RequestReviewsSummaryOptions {
  productCode: number;
}

export const requestAiSummary = createAsyncThunk<
  ReviewSummaryResponse | null,
  RequestReviewsSummaryOptions
>('reviews/requestAiSummary', ({ productCode }) => fetchReviewSummary(productCode));

export interface RequestReviewsPageOptions {
  /** A fetch the page makes itself, which the live region does not announce. */
  autoInitiated?: boolean;
  page: number;
  productCode: number;
  /** Star filter, 1 to 5, or null/undefined for all ratings. */
  rating?: ReviewRatingFilter;
}

export interface RequestPhotoReviewsOptions {
  productCode: number;
}

/**
 * The most recent reviews that carry a photo, for the customers' photos strip. Its own
 * request rather than a read of the list's first page: photos are rare, so the photos a
 * product has are mostly on reviews far down the list.
 */
export const requestPhotoReviews = createAsyncThunk<ReviewsPage | null, RequestPhotoReviewsOptions>(
  'reviews/requestPhotoReviews',
  ({ productCode }) => fetchProductReviewsClient(productCode, { media: 'photo' }),
);

/**
 * A page of the Feefo reviews list, through our own API route. The first page also carries
 * the rating breakdown and partner insights for the summary section and the drawer.
 */
export const requestReviewsPage = createAsyncThunk<ReviewsPage | null, RequestReviewsPageOptions>(
  'reviews/requestReviewsPage',
  ({ page, productCode, rating = null }) =>
    fetchProductReviewsClient(productCode, { page, rating }),
);
